import BaseCanvasElement from "../base-canvas-element";
import { Image, Text } from "react-konva";
import type { NounIconElement as TypeNounIconElement } from "shared/datamodel/schemas/noun-icon";
import { syncServiceAtom, transformerRefAtom } from "state-atoms";
import { useAtomValue } from "jotai";
import { useNounIcon } from "./use-icon-from-cache";
import { useEffect } from "react";
import { CanvasSpinner } from "../../utility-elements/canvas-spinner";
import { Sizes } from "frontend/data/shapes/sizes";

export function NounIconElement({
  id,
  element,
  onResize,
  changeElement,
  isSelected,
  isSelectable,
  isEditingLink,
}: {
  id: string;
  element: TypeNounIconElement;
  onResize: any;
  changeElement: any;
  isSelected: boolean;
  isSelectable: boolean;
  isEditingLink: boolean;
}) {
  const size = Sizes.get().nounIcon.size;
  const syncService = useAtomValue(syncServiceAtom);
  const transformerRef = useAtomValue(transformerRefAtom);
  const icon = useNounIcon(element.id, syncService?.getReplicache());

  // Workaround to a bug in KonvaShimmer. Shimmer's x starts at -width, so the transformer is too large
  useEffect(() => {
    if (icon && transformerRef?.current) {
      transformerRef.current.forceUpdate();
    }
  }, [icon, transformerRef]);

  return (
    <BaseCanvasElement
      id={id}
      type={"nounIcon"}
      element={element}
      x={element.x}
      y={element.y}
      onResize={onResize}
      isSelected={isSelected}
      isSelectable={isSelectable}
      isEditingLink={isEditingLink}
      changeElement={changeElement}
    >
      {icon == undefined ? (
        <CanvasSpinner x={size / 2} y={size / 2} />
      ) : icon.type === "ready" || icon.type === "preview" ? (
        <Image width={size} height={size} image={icon.data} />
      ) : (
        <Text width={size} height={size} align="center" verticalAlign="middle" text="Error loading icon" />
      )}
    </BaseCanvasElement>
  );
}
